import { router } from "@inertiajs/react";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import {
  deep_dive_bizminer_app_pillar_insight_functional_insight_path,
  kpi_drivers_bizminer_app_pillar_insight_functional_insight_path,
  overview_bizminer_app_pillar_insight_functional_insight_path,
} from "@/routes";

interface FunctionalInsightTabsProps {
  currentTab: string;
  pillarInsightId: number;
  categoryId: string;
}

export function FunctionalInsightTabs({
  currentTab,
  pillarInsightId,
  categoryId,
}: FunctionalInsightTabsProps) {
  const tabs = [
    { value: "overview", label: "Summary" },
    { value: "deep_dive", label: "Deep Dive" },
    { value: "kpi_drivers", label: "KPI Drivers" },
  ];

  const handleTabChange = (value: string) => {
    let path: string;

    switch (value) {
      case "overview":
        path = overview_bizminer_app_pillar_insight_functional_insight_path(
          pillarInsightId,
          categoryId,
        );
        break;
      case "deep_dive":
        path = deep_dive_bizminer_app_pillar_insight_functional_insight_path(
          pillarInsightId,
          categoryId,
        );
        break;
      case "kpi_drivers":
        path = kpi_drivers_bizminer_app_pillar_insight_functional_insight_path(
          pillarInsightId,
          categoryId,
        );
        break;
      default:
        return;
    }

    router.visit(path, {
      preserveScroll: true,
      preserveState: false,
      replace: false,
    });
  };

  return (
    <Tabs value={currentTab} onValueChange={handleTabChange}>
      <TabsList className="w-max justify-start">
        {tabs.map((tab) => (
          <TabsTrigger key={tab.value} value={tab.value} className="flex-none">
            {tab.label}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
}
